import React from 'react';

import classNames from 'classnames/bind';
import style from './QuoteNoPhoto.scss';
const ctx = classNames.bind(style);

const QuoteNoPhoto = props => (
  <div className={ctx('quote')}>
    <div className={ctx('text')}>{props.text}</div>
  </div>
);

export default QuoteNoPhoto;

/*
<span className={ctx('nick')}>({props.author.nick})</span>
*/
/*
https://github.com/ctrlplusb/react-sizeme
*/
